@import '../../../node_modules/bootstrap/scss/functions';
@import '../../../node_modules/bootstrap/scss/variables';
@import '../../../node_modules/bootstrap/scss/variables-dark';
@import '../../../node_modules/bootstrap/scss/maps';
@import '../../../node_modules/bootstrap/scss/mixins';
@import '../../../node_modules/bootstrap/scss/reboot';
@import '../../mixins/choice-input';
@import '../../../../style/src/typography/mixins';

$switch-inset: 2px;
$switch-height: 22px;
$switch-width: 44px;

:host {
	@include zds-typography('body');

	color: var(--zds-text-color-base);
	display: block;
}

.choice-input {
	@include choice-input(
		$choice-input-height: $switch-height,
		$choice-input-padding-x: var(--zds-switch-inset-x),
		$choice-input-padding-y: var(--zds-switch-inset-y),
		$choice-input-width: $switch-width
	);

	display: inherit;

	&__label-text {
		margin-left: 0.75rem;
	}

	&__input-graphic {
		background-color: var(--zds-color-grey-200);
		border: 0;
		border-radius: 100px;
		transition: background-color var(--zds-transition-sm);

		// Focus
		.choice-input__input-native:focus-visible + & {
			box-shadow: var(--zds-switch-box-shadow-off);
		}

		// Checked
		.choice-input__input-native:checked + & {
			background-color: var(--zds-input-background-on);
		}

		// Invalid
		.choice-input--is-invalid .choice-input__input-native + & {
			background-color: var(--zds-input-border-color-invalid);
			opacity: 0.7;
		}

		// Focus & checked
		.choice-input__input-native:focus-visible:checked + & {
			box-shadow: var(--zds-input-box-shadow-focus);
		}

		// Checked & invalid
		.choice-input--is-invalid .choice-input__input-native:checked + & {
			opacity: 1;
		}

		// Focus & invalid
		.choice-input--is-invalid .choice-input__input-native:focus-visible + & {
			box-shadow: var(--zds-input-box-shadow-invalid);
		}
	}

	&__input-graphic-dot {
		background-color: var(--zds-color-white);
		border-radius: 100px;
		bottom: $switch-inset;
		box-shadow: 1px 2px 2px rgb(0 0 0 / 26%);
		height: $switch-height - 2 * $switch-inset - 4px;
		left: $switch-inset + 2px;
		position: absolute;
		top: $switch-inset + 2px;
		transform-origin: center;
		transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
		width: $switch-height - 2 * $switch-inset - 4px;

		.choice-input__input-native:checked + .choice-input__input-graphic & {
			animation: switch-animation 150ms cubic-bezier(0.4, 0, 0.2, 1);
			left: $switch-width - $switch-height + $switch-inset;
		}

		.choice-input__input-native:not(:checked) + .choice-input__input-graphic & {
			animation: switch-animation 150ms cubic-bezier(0.4, 0, 0.2, 1);
		}

		.choice-input:not(.choice-input--has-loaded) & {
			animation-duration: 0ms;
		}

		.choice-input__input-native:disabled + .choice-input__input-graphic & {
			animation: none;
			transition: none;
		}

		&::after {
			background: linear-gradient(
					45deg,
					transparent 45%,
					var(--zds-color-grey-600) 45%,
					var(--zds-color-grey-600) 55%,
					transparent 55%
				),
				linear-gradient(
					-45deg,
					transparent 45%,
					var(--zds-color-grey-600) 45%,
					var(--zds-color-grey-600) 55%,
					transparent 55%
				);
			border-radius: 100px;
			content: '';
			display: block;
			height: 10px;
			margin-left: 2px;
			margin-top: 2px;
			opacity: 0.5;
			position: absolute;
			transform-origin: center;
			transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
			width: 10px;

			.choice-input__input-native:checked + .choice-input__input-graphic & {
				background: none;
				border: 2px solid var(--zds-input-background-on);
				border-left: 0;
				border-radius: 0;
				border-top: 0;
				height: 12px;
				margin-left: 4px;
				margin-top: 0;
				opacity: 1;
				transform: rotate(45deg) scale(0.8);
				width: 6px;
			}

			.choice-input--is-invalid & {
				background: linear-gradient(
						45deg,
						transparent 45%,
						var(--zds-color-danger) 45%,
						var(--zds-color-danger) 55%,
						transparent 55%
					),
					linear-gradient(
						-45deg,
						transparent 45%,
						var(--zds-color-danger) 45%,
						var(--zds-color-danger) 55%,
						transparent 55%
					);
				opacity: 1;
			}

			.choice-input--is-invalid .choice-input__input-native:checked + .choice-input__input-graphic & {
				border-color: var(--zds-color-danger);
			}
		}

		.choice-input__input-native:not(:disabled):hover + .choice-input__input-graphic & {
			transform: scale(1.15);
		}

		.choice-input__input-native:not(:disabled):active + .choice-input__input-graphic & {
			transform: scale(1.3);
		}
	}

	@keyframes switch-animation {
		0% {
			transform: scale(1);
		}

		50% {
			transform: scale(0.92);
		}

		100% {
			transform: scale(1);
		}
	}
}
